import {
  DestroyRef,
  EnvironmentProviders,
  Injector,
  Provider,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptorFn } from '../interceptors/auth.interceptor';
import { impersonationInterceptorFn } from '../interceptors/impersonation.interceptor';

export function provideAuthServices(): (Provider | EnvironmentProviders)[] {
  // Order matters: impersonation runs first on the request (adds header) and last on the
  // response (so it can clear its state after auth has decided not to refresh).
  return [
    provideHttpClient(withInterceptors([impersonationInterceptorFn, authInterceptorFn])),
    // La sesión al día escucha desde el arranque: entrar y salir de soporte relee `/auth/me` aunque
    // ninguna vista haya preguntado todavía por un permiso (botones por rol, 5.6). Con `import()`:
    // el bundle inicial tiene ~1 kB de margen y esto no lo necesita para pintar nada.
    //
    // Si cuando llega el `import()` la app ya no existe (su inyector se destruyó: un test que
    // terminó), no hay sesión que mantener al día y no se crea nada. Si el `import()` falla (el
    // trozo no llegó), la falla sigue su camino hasta el manejador global de errores
    // (`provideBrowserGlobalErrorListeners`): no se traga. Sin este oyente la consola no relee al
    // entrar o salir de soporte, pero los permisos siguen bien: el soporte se lee de la pestaña.
    provideEnvironmentInitializer(() => {
      const inyector = inject(Injector);
      let vivo = true;
      inject(DestroyRef).onDestroy(() => {
        vivo = false;
      });
      void import('../permisos/sesion-al-dia.service').then((m) => {
        if (vivo) inyector.get(m.SesionAlDia);
      });
    }),
  ];
}
